import { Action } from '@reduxjs/toolkit'

import { CreateNewBucketListAction } from '../actions/createNewBucketListActions'

export type CreateNewBucketListState = {
  isOpen: boolean
  itemToAddOnCreation: {
    itemId: string
    itemType: GQL_Searchable
    source: string
  }
  actionToReplayOnClose: Action
}

export type CreateNewBucketListRootState = {
  createNewBucketList: CreateNewBucketListState
}

const initialState: CreateNewBucketListState = {
  isOpen: false,
  itemToAddOnCreation: null,
  actionToReplayOnClose: null,
}

const createNewBucketListReducer = (
  state = initialState,
  action: CreateNewBucketListAction,
) => {
  switch (action.type) {
    case 'OPEN_CREATE_NEW_BUCKET_LIST': {
      const { itemToAddOnCreation = null, actionToReplayOnClose = null } =
        action

      return {
        ...state,
        isOpen: true,
        itemToAddOnCreation,
        actionToReplayOnClose,
      }
    }
    case 'CLOSE_CREATE_NEW_BUCKET_LIST':
      return {
        ...state,
        isOpen: false,
        itemToAddOnCreation: null,
        actionToReplayOnClose: null,
      }
    default:
      return state
  }
}

export default createNewBucketListReducer
